/** Unwraps the `data` envelope of an API success response. */
export const responseData = <Data>(response: { readonly data: Data }): Data => response.data
